import { render, staticRenderFns } from "./reports-metric-single.vue?vue&type=template&id=126a9d48&scoped=true"
import script from "./reports-metric-single.vue?vue&type=script&lang=js"
export * from "./reports-metric-single.vue?vue&type=script&lang=js"
import style0 from "./reports-metric-single.vue?vue&type=style&index=0&id=126a9d48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a9d48",
  null
  
)

export default component.exports